import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationExternalIntegrationLogEntry } from 'lib-shared-types-api';

type RoutedThroughIntegrationProps = {
  node: ConversationAutomationExternalIntegrationLogEntry;
};
export function RoutedThroughIntegration({
  node,
}: RoutedThroughIntegrationProps): JSX.Element {
  const { outcome } = node;

  if (outcome && outcome.type !== 'success') {
    const errorMessage =
      'error_message' in outcome ? outcome.error_message : '';
    const errorCode = 'response_code' in outcome ? outcome.response_code : '';
    const timeoutMessage = outcome.type === 'timeout' ? 'Timeout' : '';
    const errorText =
      errorMessage || errorCode || timeoutMessage || 'An error occurred';
    return (
      <Text.Paragraph>
        Integration · Failed with error: {errorText}
      </Text.Paragraph>
    );
  }

  if (outcome && outcome.type === 'success') {
    return (
      <Text.Paragraph>
        Integration · Successfully called integration endpoint
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>
      Integration · Automation visited integration action
    </Text.Paragraph>
  );
}
